import Pages from "enums/Pages";
import { Sliders } from "react-feather";
import { useTranslation } from "react-i18next";
import { FC, useEffect, useState } from "react";
import InnerPageLayout from "layouts/InnerPageLayout";
import DefaultPageLayout from "layouts/DefaultPageLayout";
import { usePageLocation } from "contexts/PageLocationContext";
import FlowDashboardFilter from "pages/FlowDashboard/FlowDashboardFilter";
import { FlowDashboardFilterProvider } from "pages/FlowDashboard/FlowDashboardFilterContext";
import TopSpeedRanking from "pages/FlowDashboard/TopSpeedRanking";
import RouteFlowMap from "pages/FlowDashboard/RouteFlowMap/RouteFlowMap";
import PageSection from "components/PageSection/PageSection";
import PageSectionHeaderAction from "components/PageSection/PageSectionHeaderAction";

const AverageSpeedPage: FC = () => {
  const { t } = useTranslation();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { setPageTitle, setLocation } = usePageLocation();

  useEffect(() => {
    setPageTitle(t("windowTitle.averageSpeed"));
    setLocation([
      {
        label: t("AverageSpeedPage.averageSpeed"),
        page: Pages.AVERAGE_SPEED
      }
    ]);
  }, [t, Pages]);

  return (
    <DefaultPageLayout>
      <InnerPageLayout>
        <FlowDashboardFilterProvider>
          <PageSection
            title={t("AverageSpeedPage.averageSpeed")}
            primaryActions={
              <PageSectionHeaderAction
                variant="contained"
                color="secondary"
                startIcon={<Sliders />}
                onClick={() => setIsFilterOpen(true)}
              >
                {t("action.filter")}
              </PageSectionHeaderAction>
            }
          >
            <FlowDashboardFilter
              open={isFilterOpen}
              setOpen={setIsFilterOpen}
            />
            <RouteFlowMap />
            <TopSpeedRanking />
          </PageSection>
        </FlowDashboardFilterProvider>
      </InnerPageLayout>
    </DefaultPageLayout>
  );
};

export default AverageSpeedPage;
